<template>
  <el-dialog title="推荐" :visible.sync="visible" :close-on-click-modal="false" @close="close">
    <el-form :model="form" label-width="180px">
      <el-form-item label="商品ID">
        <el-input v-model="form.productId" readonly></el-input>
      </el-form-item>
      <el-form-item label="推荐到">
        <el-radio-group v-model="form.rootCatId">
          <el-radio v-for="cat in cats" :key="cat.id" :label="cat.id">{{ cat.name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="close()">取消</el-button>
      <el-button type="primary" @click.native="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        rootCatId: null,
        productId: null,
        sort: 0,
      },
      cats: [],
    };
  },
  methods: {
    async show(productId) {
      try {
        const product = await this.axios.get("mall:/api/admin/product/" + productId);
        if (!product.cats || !product.cats.length) {
          this.$notify.error("请先设置商品所属分类");
          return;
        }
        for (let i = 0; i < product.cats.length; i++) {
          const cat = product.cats[i][0];
          let exists = false;
          for (let j = 0; j < this.cats.length; j++) {
            if (this.cats[j].id === cat.id) {
              exists = true;
              break;
            }
          }
          if (!exists) {
            this.cats.push(cat);
          }
        }
        this.form.productId = productId;
        this.visible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async submit() {
      try {
        await this.axios.form("mall:/api/admin/recommend-for-you/create", this.form);
        this.close();
        this.$message.success("添加成功");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    close() {
      this.form = {
        rootCatId: null,
        productId: null,
        sort: 0,
      };
      this.cats = [];
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
